import { useCallback } from "react";

const useScrollLock = () => {
  const lockScroll = useCallback(() => {
    document.documentElement.style.overflow = "hidden";
    document.body.style.overflow = "hidden";
  }, []);

  const unlockScroll = useCallback(() => {
    document.documentElement.style.overflow = "";
    document.body.style.overflow = "";
  }, []);

  return { lockScroll, unlockScroll };
};

export default useScrollLock;
